import { render, staticRenderFns } from "./AxWorkspacesMigration.vue?vue&type=template&id=0cbc91c7&"
import script from "./AxWorkspacesMigration.vue?vue&type=script&lang=ts&"
export * from "./AxWorkspacesMigration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports